import MainContainer from '../../ui_components/MainContainer';
import styled from 'styled-components';
import SpaceActionsButtonsAndAvatarRender from './SpaceActionsButtonsAndAvatarRender';
import WrestlerActions from '../../wrestler_page_components/WrestlerActions';
import WrestlerUserInfo from '../../wrestler_page_components/WrestlerUserInfo';
import AlboDoroWrestlerRender from './AlboDoroWrestlerRender';
import InfoFileWrestlerRender from './InfoFileWrestlerRender';
import TopMatchWrestlerRender from './TopMatchWrestlerRender';
import PrimeWrestlerRender from './PrimeWrestlerRender';
import NemiciAmiciWrestlerRender from './NemiciAmiciWrestlerRender';
import ArchivioRender from './ArchivioRender';
import WrestlerCards from '../../wrestler_page_components/WrestlerCards';
import type { User } from '../../../types';
import type { WrestlerWithStats } from '../../../types';
import type { Card } from '../../../types/models/card';

const NameWrestler = styled.h1`
    font-size: 23px;
    font-weight: 800;
    margin: 0;
    text-transform: uppercase;
    width: 100%;
    text-align: center;
    margin: 20px 0;
`;

const ActionsWrapper = styled.div`
    width: 100%;
    margin-bottom: 12px;

    /* Touch target più comodi su mobile (min 44px altezza) */
    & button {
        min-height: 44px;
        padding: 0.5rem 1rem;
        font-size: 14px;
    }
`;

interface ManSingleWrestlerRenderPageProps {
    wrestlerData: WrestlerWithStats;
    user: User | null;
    onWrestlerDataUpdate: () => void;
    wrestlerCards: Card[];
    isLoadingCards: boolean;
    isAlboDoroOpen: boolean;
    isInfoPageOpen: boolean;
    isPrimePageOpen: boolean;
    isArchivioPageOpen: boolean;
    isNemiciAmiciPageOpen: boolean;
    isTopMatchPageOpen: boolean;
    handleClickAlboDoroOpen: () => void;
    handleClickInfoPageOpen: () => void;
    handleClickPrimePageOpen: () => void;
    handleClickArchivioPageOpen: () => void;
    handleClickNemiciAmiciPageOpen: () => void;
    handleClickTopMatchPageOpen: () => void;
}

function ManSingleWrestlerRenderPage({
    wrestlerData,
    user,
    onWrestlerDataUpdate,
    wrestlerCards,
    isLoadingCards,
    isAlboDoroOpen,
    isInfoPageOpen,
    isPrimePageOpen,
    isArchivioPageOpen,
    isNemiciAmiciPageOpen,
    isTopMatchPageOpen,
    handleClickAlboDoroOpen,
    handleClickInfoPageOpen,
    handleClickPrimePageOpen,
    handleClickArchivioPageOpen,
    handleClickNemiciAmiciPageOpen,
    handleClickTopMatchPageOpen,
}: ManSingleWrestlerRenderPageProps) {
    return (
        <MainContainer
            isMobile={true}
            padding='10px'
        >
            {/* Nome Wrestler */}
            <NameWrestler className='name-wrestler'>{wrestlerData.name}</NameWrestler>

            {/* Azioni Associati / Disassocia (solo se loggato, stesse regole della pagina desktop) */}
            <ActionsWrapper className='wrestler-actions-mobile'>
                <WrestlerActions
                    user={user}
                    wrestlerData={wrestlerData}
                    onWrestlerDataUpdate={onWrestlerDataUpdate}
                />
            </ActionsWrapper>

            {/* Nome sul sito e nome sul forum (come in desktop); nessun utente = "Nessun utente assegnato" */}
            <WrestlerUserInfo wrestlerData={wrestlerData} />

            {/* Bottoni che rimandano ad altre sezioni e avatar */}
            <SpaceActionsButtonsAndAvatarRender 
                wrestlerData={wrestlerData}
                isAlboDoroOpen={isAlboDoroOpen}
                isInfoPageOpen={isInfoPageOpen}
                isPrimePageOpen={isPrimePageOpen}
                isArchivioPageOpen={isArchivioPageOpen}
                isNemiciAmiciPageOpen={isNemiciAmiciPageOpen}
                isTopMatchPageOpen={isTopMatchPageOpen} 
                handleClickAlboDoroOpen={handleClickAlboDoroOpen}
                handleClickInfoPageOpen={handleClickInfoPageOpen}
                handleClickPrimePageOpen={handleClickPrimePageOpen}
                handleClickArchivioPageOpen={handleClickArchivioPageOpen}
                handleClickNemiciAmiciPageOpen={handleClickNemiciAmiciPageOpen}
                handleClickTopMatchPageOpen={handleClickTopMatchPageOpen}
            />

            {/* Albo Doro Wrestler Render  */}
            {isAlboDoroOpen && (
            <AlboDoroWrestlerRender
                    belts={wrestlerData.belts}
                />
            )}

            {/* Info Wrestler Render */}
            {isInfoPageOpen && (
                <InfoFileWrestlerRender
                    wrestlerData={wrestlerData}
                />
            )}

            {/* Top Match Wrestler Render */}
            {isTopMatchPageOpen && (
                <TopMatchWrestlerRender
                    bestFights={wrestlerData.bestFights}
                    wrestlerId={wrestlerData.id}
                    wrestlerName={wrestlerData.name}
                    wrestlerAvatarPath={wrestlerData.avatar_path}
                />
            )}

            {/* Prime Wrestler Render */}
            {isPrimePageOpen && (
                <PrimeWrestlerRender 
                    bestYears={wrestlerData.bestYears}
                    wrestlerId={wrestlerData.id}
                />
            )}

            {/* Nemici Amici Wrestler Render */}
            {isNemiciAmiciPageOpen && (
                <NemiciAmiciWrestlerRender
                    mostChallenged={wrestlerData.mostChallenged}
                />
            )}

            {/* Archivio Wrestler Render */}
            {isArchivioPageOpen && (
                <ArchivioRender
                    allFights={wrestlerData.allFights}
                    wrestlerId={wrestlerData.id}
                />
            )}

            {/* Carte associate — sempre visibili se presenti */}
            {(isLoadingCards || wrestlerCards.length > 0) && (
                <WrestlerCards
                    cards={wrestlerCards}
                    isLoading={isLoadingCards}
                    isAuthenticated={!!user}
                />
            )}

        </MainContainer>
    );
}

export default ManSingleWrestlerRenderPage;